// extracted by mini-css-extract-plugin
export default {"main":"Main_main__Iqx-H","wrap":"Main_wrap__NwTYf","title":"Main_title__lpgHl","text":"Main_text__nkr9P","bg":"Main_bg__2C2No"};